require("!!/var/www/melochenator_prod/frontend/node_modules/script-loader/addScript.js")(require("!!/var/www/melochenator_prod/frontend/node_modules/raw-loader/index.js!/var/www/melochenator_prod/frontend/node_modules/bootstrap-select/dist/js/bootstrap-select.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/bootstrap-select/dist/js/bootstrap-select.min.js
// module id = 904
// module chunks = 12